export default "__VITE_ASSET__DNZZtafZ__"